export const CDN_URL = "https://assets.webbank.com"
